import { render } from "./Bac.vue?vue&type=template&id=29ba02c6&scoped=true"
import script from "./Bac.vue?vue&type=script&lang=js"
export * from "./Bac.vue?vue&type=script&lang=js"

import "./Bac.vue?vue&type=style&index=0&id=29ba02c6&scoped=true&lang=css"

import exportComponent from "E:\\项目\\5.0版本的老界面\\5.0版本的老界面\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ba02c6"]])

export default __exports__